import { Component } from '@angular/core';
import * as $ from 'jquery';
@Component({
    selector: 'app-footer-root',
    templateUrl: './app-footer.component.html',
    styleUrls: ['./app-footer.component.css']
})

export class AppFooterComponent {
    ano: number = 0;
    mes: number = 0;
    dia: number = 0;

    ngOnInit() {
        this.ano = new Date().getFullYear();
        this.mes = new Date().getMonth();
        this.dia = new Date().getDate();

    }

    fnTeste() {
        $("html, body").animate({ scrollTop: 0 }, 900);
        return false;

    }
}
